export default __webpack_public_path__ + "9fb78728b99b92de88c5ef99e3668234.png";